import { Component, OnInit, Input, EventEmitter, Output, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import Html from '../../../assets/declarations/dec.html';
import { LookupService } from '../../services';
import {  IdDetailsModel, crsDetailsModel,  benDetailsModel } from '../../models';
import tncHtml from '../../../assets/tnc/alltnc.html';
import { applicantDetailsModel } from 'src/app/models/account-opening-models/applicant-details.model';
import { NgForm } from '@angular/forms';
import { FirebaseService } from 'src/app/services/firebase.service';


@Component({
  selector: 'app-declarations',
  templateUrl: './declarations.component.html',
  styleUrls: ['./declarations.component.css']
})
export class DeclarationsComponent implements OnInit,OnChanges {
  @Input() accountAppModel: any;
  @Output() onConsent: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() Lookups: any;
  @ViewChild(NgForm) form;
  dec: any = Html;
  alltnc: any = tncHtml;
  onlyCRSDetail = true;
  onlyBenDetail = true;
  theCheckbox: any;
  applicantNum = 1;
  appDetails:applicantDetailsModel[];
  yes_id: String;
  pep:any;


  idDetails: IdDetailsModel[] = [{ name: 'Abc', idNo: '', idType: '', countryOfIssuance: '' }];
  crsDetails: crsDetailsModel[] = [{ CountryOfTaxResidenceUDF: '', TINUDF: '', TINReasonUDF: '', OutsidePakCheck: '' }];
  benDetails: benDetailsModel[] = [{ FirstNameUDF: '', NationalIdUDF: '', CountryOfIssuanceUDF: '' }];
  // Lookups: any = [];
  showSpinner = false;
  constructor(private lookupService: LookupService,public firebase: FirebaseService) {
  }
  ngOnChanges(changes: SimpleChanges): void {
    if(this.Lookups&&this.Lookups.Y_N){

      this.yes_id=this.Lookups.Y_N.filter((element)=> {return element.HiddenValue=='Y'})[0].LookupId+"";
    }


  }
  BindPEP(data)
  {
    console.log("Binding PEP");
   
  }

  ngOnInit() {
    this.bindModelDropDown();


    if (!this.accountAppModel['CRSDetails'] || !this.accountAppModel['CRSDetails'][0])
      this.accountAppModel['CRSDetails'] = this.crsDetails;
      if (!this.accountAppModel['TmxBeneficialOwner'] || !this.accountAppModel['TmxBeneficialOwner'][0])
      this.accountAppModel['TmxBeneficialOwner'] = this.benDetails;

  }
  bindModelDropDown() {
    this.showSpinner = true;
    //    this.lookupService.getAllLookups().subscribe(lookupResponse => {
    //      this.lookupService.saveLookups(lookupResponse);
    //      this.Lookups.CustomerTypeLkp = this.lookupService.getLookupByType('CUSTOMER_TYPE');
    //     this.Lookups.YesNo = this.lookupService.getLookupByType('YES_NO_BIT');
    //     this.Lookups.ApproxNetAssetPkrLkp = this.lookupService.getLookupByType('NET_ASSET');
    //     this.Lookups.MonthlyIncomePkrLkp = this.lookupService.getLookupByType('MONTHLY_INCOME');

    //  this.showSpinner = false;
    //    });
  }


  postDetails() {
    //this.lookupService.getAllLookups();

  }
  addIdDetail() {
    this.idDetails.push(new IdDetailsModel());
  }

  removeCRSDetail(index:number,i:number) {
    if (this.appDetails[index]['crsDetails'].length > 1) {
      this.appDetails[index]['crsDetails'].splice(i, 1);
    }

    if (this.appDetails[index]['crsDetails'].length < 2) {
      this.onlyCRSDetail = true;
    }
  }
  addCRSDetail(index:number) {


    this.appDetails[index]['crsDetails'].push(new crsDetailsModel());

    if (this.appDetails[index]['crsDetails'].length > 1) {
      this.onlyCRSDetail = false;
    }

  }


  removeBenDetail(index) {
    if (this.benDetails.length > 1) {
      this.benDetails.splice(index, 1);
    }

    if (this.benDetails.length < 2) {
      this.onlyBenDetail = true;
    }
  }
  addBenDetail() {
    this.benDetails.push(new benDetailsModel());
    if (this.benDetails.length > 1) {
      this.onlyBenDetail = false;
    }
  }

  removeIdDetail(index) {
    this.idDetails.splice(index, 1);
  }

  onTNCchange(data) {
    this.onConsent.emit(data);
    this.firebase.logEvent('I Agree with TnCs');
  }

  anyApplicantOutsidePak(){
    return false;
  }

}
